import { render } from "./servidorAll.vue?vue&type=template&id=010e0a23&scoped=true"
import script from "./servidorAll.vue?vue&type=script&lang=js"
export * from "./servidorAll.vue?vue&type=script&lang=js"

import "./servidorAll.vue?vue&type=style&index=0&id=010e0a23&lang=scss&scoped=true"
import "./servidorAll.vue?vue&type=style&index=1&id=010e0a23&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-010e0a23"]])

export default __exports__